import config from "@Config/index";
import { getAvailableStartingPricingHelper } from "@Pages/BookForm/utils";
import { getPricingCurrency } from "@Pages/Bookings/utils/getFormattedPricing";
import { getAvailableStartingPricing } from "@Pages/Search/components/SearchListItem/helper";

export const SHOW_NEW_HEADER = true;
export const SHOW_NEW_FOOTER = true;
export const SHOW_NEW_BOTTOM_NAVBAR = true;
export const BASE_OSS_URL = "https://oss-assets.amberstudent.cn/assets/static";
export const FACEBOOK_URL = "https://www.facebook.com/amberstudent";
export const TWITTER_URL = "https://twitter.com/amberstudent_";
export const INSTAGRAM_URL = "https://www.instagram.com/amberstudent/";
export const YOUTUBE_URL = "https://www.youtube.com/channel/UCzm8GT3xWuXqQt9O7CFpqJw";
export const LINKEDIN_URL = "https://www.linkedin.com/company/amberstudent";
export const PINTEREST_URL = "https://www.pinterest.com/amberstudent/";
export const TIKTOK_URL = "https://www.tiktok.com/@amberstudent.com";
export const WECHAT_URL = "https://mp.weixin.qq.com/s/OtqDxSQd6nOEWlgLWVv6PA";
export const MINIPROGRAM_URL = "https://work.weixin.qq.com/ca/cawcdebb14ff6d0bda";
export const LOGO_URL =
  "https://prod-static-assets.amberstudent.com/images/logo/amber_red_logo_small.png?fm=pjpg&auto=format";
export const BASE_IMG_URL = config.IS_CHINA_APP
  ? "https://assets.amberstudent.cn/prod-static-assets/images/"
  : "https://prod-static-assets.amberstudent.com/images/";
export const PLG_CONTENT_URL = "https://static-assets.amberstudent.com/images/plg-content/";
export const TRUSTPILOT_REVIEWS_URL = "https://www.trustpilot.com/review/amberstudent.com";
export const TRUSTPILOT_RATING = 4.8;
export const TRUSTPILOT_REVIEW = "10.4K";
export const TRUSTPILOT_REVIEW_COUNT = "10,400";
export const BED_COUNT = "2M+";
export const HOME_URL = "/";
export const BLOG_URL = "/blog";
export const HELP_URL = "/help";
// export const CAREERS_URL = 'https://amberstudent.freshteam.com/jobs'
export const MAP_ID = "c71fda9540256f79";
export const IMAGE_BASE_URL = "https://prod-static-assets.amberstudent.com/images/map/";
export const UNIVERSITY_ICON = {
  url: `${IMAGE_BASE_URL}university_center.svg`,
  scaledSize: { width: 38, height: 56 },
};
export const INVENTORY_ICON = {
  url: `${IMAGE_BASE_URL}city_center.svg`,
  scaledSize: { width: 38, height: 56 },
};

export const APP_LINK = "/api/flag/redirect_to_install_app";
export const CAREERS_URL = "/career";
export const ABOUT_URL = "/about";
export const DASHBOARD_URL = "/dashboard";
export const GROUP_BOOKINGS_URL = "/group-booking";
export const REFER_URL = "/referral-programme";
export const LEADS_URL = "/places/leads";
export const LEADS_LIST = "/list";
export const HOW_IT_WORKS_URL = "/how-it-works";
export const CONTACT_URL = "/contact";
export const NEWSROOM_URL = "/news";
export const AMBASSADOR_URL = "/ambassador";
export const AMBERPLUS_URL = "/plus";
export const SCHOLARSHIP_URL = "/scholarship";
export const EXAMS_URL = "/exams";
export const TERMS_URL = "/terms";
export const PRIVACY_URL = "/privacy";
export const SITEMAP_URL = "/sitemap";
export const MEDIA_MENTION_URL = "/media";
export const PODCAST_URL = "/podcast";
export const PROFILE_URL = "/profile";
export const PROFILE_LEADS_URL = "/profile/leads";
export const PROFILE_PAYMENTS_URL = "/profile/payments";
export const PROFILE_SHORTLIST_URL = "/profile/shortlist";
export const PROFILE_APPLICATIONS_URL = "/profile/applications";
export const PARTNER_WITH_AMBER_URL = "/partner";
export const UNIVERSITIES_URL = "/university-partnerships";
export const ADDRESS_US = "40 E Main St #1215 Newark DE, USA";
export const ADDRESS_US_2 = "40 E Main St # 1215 Newark 19711-4639";
export const ADDRESS_INDIA = "91 Springboard, Creaticity, Yerawada, Pune, Maharashtra 411006";
export const REGISTERED_NAME_INDIA = "Amber Healthcare Solutions Pvt Ltd.";
export const REGISTERED_NAME_US = "Amber Internet solutions Inc.";
export const REGISTERED_NAME_CN = "上海虞昇网络科技有限公司";
export const ADDRESS_CN = "上海市宝山区长建路199号10幢";
export const EMAIL_1 = "contact@amberstudent.com";
/** Talent Acquisition's inbox — the address the /job-opening FAQ points candidates at. */
export const HIRING_EMAIL = "hiring@amberstudent.com";
export const PHONE_1 = {
  country_code: "+44",
  country_code_raw: "44",
  country_code_name: "gb",
  full_number: "+44 7456741634",
  number: "7456741634",
};
export const PHONE_2 = {
  country_code: "+91",
  country_code_raw: "91",
  country_code_name: "in",
  full_number: "+91 8035735724",
  number: "8035735724",
};
export const PHONE_3 = {
  country_code: "+1",
  country_code_raw: "1",
  country_code_name: "us",
  full_number: "+1 9176959425",
  number: "9176959425",
};
export const PHONE_4 = {
  country_code: "+61",
  country_code_raw: "61",
  country_code_name: "au",
  full_number: "+61 868457597",
  number: "868457597",
};
export const PHONE_5 = {
  country_code: "+86",
  country_code_raw: "86",
  country_code_name: "cn",
  full_number: "+86 13839566793",
  number: "13839566793",
};
export const PHONE_7 = {
  country_code: "+44",
  country_code_raw: "44",
  country_code_name: "gb",
  full_number: "+44 7723497306",
  number: "7723497306",
};

export const PHONE_8 = {
  country_code: "+91",
  country_code_raw: "91",
  country_code_name: "in",
  full_number: "+91 9513884849",
  number: "9513884849",
};

export const PHONE_9 = {
  country_code: "+1",
  country_code_raw: "1",
  country_code_name: "us",
  full_number: "+1 7048791919",
  number: "7048791919",
};
// Note: This needs to be updated for whitelabel
export const PHONE_WHATSAPP_OUTBOUND = {
  country_code: "+44",
  country_code_raw: "44",
  country_code_name: "gb",
  full_number: "+44 7888863490",
  number: "7888863490",
};
export const PAGE = {
  HOME: "home_page",
  SEARCH: "search_page",
  PROFILE: "profile_page",
  INVENTORY: "inventory_page",
  LEADFORMPAGE: "lead_form_page",
  BOOKFORM: "book_form",
  PAYMENTFORM: "payment_form",
  ACTIVITY: "activity_page",
  MAP: "map",
  PROPERTY: "property_page",
  NEARBY: "nearby_page",
  BLOG: "blog_page",
};
export const PROFILE_DROPDOWN = "Profile_dropdown";
export const REVIEW_COLLECTION = "review_collection";
// webflow urls
export const WEBFLOW_DEV = {
  BLOG_URL: "https://amber-blog-cms.webflow.io",
  NEWS_URL: "https://amber-newsroom.webflow.io",
  PLUS_URL: "https://amber-plus.webflow.io",
  MASTER_URL: "https://master-amber.webflow.io",
  PODCAST_URL: "https://amber-podcast.webflow.io",
};

export const WEBFLOW_PROD = {
  BLOG_URL: "https://b.internal.amberstudent.com",
  NEWS_URL: "https://n.internal.amberstudent.com",
  PLUS_URL: "https://plus.internal.amberstudent.com",
  MASTER_URL: "https://pages.internal.amberstudent.com",
  PODCAST_URL: "https://podcast.internal.amberstudent.com",
};
export const FACEBOOK_MESSENGER_URL = "https://m.me/amberstudent";
// Note: This needs to be updated for whitelabel
export const WHATSAPP_URL = `https://wa.me/${PHONE_WHATSAPP_OUTBOUND.country_code_raw}${PHONE_WHATSAPP_OUTBOUND.number}`;

export const SHOW_APP_BANNER_SESSION = "show_app_banner_session";
export const SCROLL_DEBOUNCE_THRESHOLD = 30;
export const A_SHOW_BANNER = "A_SHOW_BANNER";
export const B_NOT_SHOW_BANNER = "B_NOT_SHOW_BANNER";

export const WEBFLOW_CACHE_TIME = 12 * 60 * 60;
export const INVENTORY_CACHE_TIME = 12 * 60 * 60; // 12 hours
export const ICP_URL = "https://beian.miit.gov.cn/";
export const ICP_LICENCE_NUMBER = "沪ICP备2025113550号-1";

export const CHINA_FOOTER_QR_MINIPROGRAM_URL = `${BASE_OSS_URL}/dwebcnqrexpanded_360.png`;
export const CHINA_FOOTER_QR_APP_DOWNLOAD_URL = `${config.IMAGE_STATIC_URL}/images/china-app-download-QR.png`;

/** Payment-method marks shown on China surfaces: WeChat Pay, Alipay, card, bank transfer. */
export const CHINA_PAYMENT_LOGOS = [
  {
    id: "wechat-pay",
    src: `${config.IMAGE_STATIC_URL}/images/weChat-Pay-logo.png`,
    width: 55,
    height: 29,
    maxHeight: 29,
  },
  {
    id: "alipay",
    src: `${config.IMAGE_STATIC_URL}/images/aliPay-logo.png`,
    width: 68,
    height: 45,
    maxHeight: 45,
  },
  {
    id: "card",
    src: `${config.IMAGE_STATIC_URL}/images/cardPay.png`,
    width: 62,
    height: 19,
    maxHeight: 19,
  },
  {
    id: "bank-transfer",
    src: `${config.IMAGE_STATIC_URL}/images/bankPay.png`,
    width: 84,
    height: 21,
    maxHeight: 21,
  },
];

export const DEFAULT_FIREBASE_CONFIG_FLAGS = {
  homePageBanner:
    '{"showBanner":true,"content":"Insider Tip: Save up to £5000! Book your student home early for the 2024 intake risk-free. Grab full refund on Visa or Uni rejection!","link":"","icon":"megaphone","withAnimation":true}',
  searchPageBanner:
    '{"showBanner":true,"content":"Insider Tip: Save up to £5000! Book your student home early for the 2024 intake risk-free. Grab full refund on Visa or Uni rejection!","link":"","icon":"megaphone","withAnimation":true}',
  propertyPageBanner:
    '{"showBanner":true,"content":"Insider Tip: Save up to £5000! Book your student home early for the 2024 intake risk-free. Grab full refund on Visa or Uni rejection!","link":"","icon":"megaphone","withAnimation":true}',
  chinaNewYearBanner:
    '{"showBanner":true,"content":"【龙年特惠】现在通过amber预订您的海外留学公寓，即可享受888元人民币的现金返还大礼！活动截止日期至2024年2月28日，赶快行动，不容错过！","link":"","icon":"megaphone","withAnimation":true}',
  isEdgeEnabled: "false",
  isProfileV2: "true",
  isHomeV2: "true",
  isAppBannerAvailable: "true",
  lazyLoadTimeout: "0",
  isBookingV2: "true",
  isReleaseV16: "true",
  newPropertyPageCities: "[]",
  isPropertyV2View: "true",
  isNewRoomTypes: "false",
  isFooterV2: "true",
  // isBookFormV2: 'true',
  isNewHome: "true",
  isDialerV2: "false",
  AmberApp: {
    appSentryTraceSampleRate: "0.3",
    appIsNewSearch: "true",
  },
  agentIds: "[]",
  showPriceTrends: "true",
  isNewPlusPage: "true",
  enableAutomatedBanners: false,
  referPageStats: { "people-referred": "10,000+", "payout-disbursed": "GBP 500K+" },
  showAppNudge: true,
  showPartnerWithUs: "true",
  showVirtualViewRequest: true,
  showPlusCategoryBannerImage: false,
  isNewLeadFormFlow: true,
  isLangChina: false,
};

export const SWIFTSELL_ENQUIRE_FLOW_VALUES = {
  ENQUIRE_FLOW: "enquire",
  LEAD_FLOW: "lead",
  DEFAULT_FLOW: "default",
};

// App download links
export const APP_DOWNLOAD_LINK = "https://amberstudent.sng.link/Djzr5/htgb?_smtype=3";

export const APP_DOWNLOAD_APP_STORE_LINK =
  "https://apps.apple.com/us/app/amber-book-student-housing/id6447250749";
export const APP_DOWNLOAD_PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.amberstudent";
export const CHINA_ANDROID_DOWNLOAD_LINK = "http://amberstudent.onelink.me/9pa8/xyf1ugbt";

// App download images
export const APP_DOWNLOAD_PLAY_STORE_IMG =
  "https://prod-static-assets.amberstudent.com/images/playStoreAppQR-hd.png";
export const APP_DOWNLOAD_APP_STORE_IMG =
  "https://prod-static-assets.amberstudent.com/images/appStoreAppQR-hd.png";

// App download Header Pages
export const APP_DOWNLOAD_OPTION_SHOWN_PAGES = [PAGE.HOME, PAGE.SEARCH, PAGE.INVENTORY];

export const SUPPORTED_LANG_CHINA = [
  {
    label: "English",
    value: "en",
  },
  {
    label: "中文",
    value: "zh",
  },
];

export const SUPPORTED_LANG = [
  {
    name: "English",
    label: "English",
    value: "en",
  },
  {
    name: "Spanish",
    label: "Español",
    value: "es",
  },
  {
    name: "French",
    label: "Français",
    value: "fr",
  },
  {
    name: "German",
    label: "Deutsch",
    value: "de",
  },
  {
    name: "Chinese",
    label: "中文",
    value: "zh",
  },
];

export const MWEB_HAMBURGER_MENU = "MWEB_HAMBURGER_MENU";
export const MWEB_APP_LAUNCH_PAGE = "MWEB_APP_LAUNCH_PAGE";
export const MWEB_HOME_PAGE = "MWEB_HOME_PAGE";
export const WEB_APP_LAUNCH_PAGE = "WEB_APP_LAUNCH_PAGE";

export const APP_DOWNLOAD_URL = {
  [PAGE.HOME]: `${BASE_IMG_URL}home-page-app-download.svg`,
  [PAGE.SEARCH]: `${BASE_IMG_URL}search-page-app-download-qr.svg`,
  [PAGE.INVENTORY]: `${BASE_IMG_URL}property-page-app-download-qr.svg`,
  [MWEB_HAMBURGER_MENU]: "https://amberstudent.sng.link/Djzr5/9qwc?_smtype=3",
  [MWEB_APP_LAUNCH_PAGE]: "https://amberstudent.sng.link/Djzr5/v8yz?_smtype=3",
  [MWEB_HOME_PAGE]: "https://amberstudent.sng.link/Djzr5/4iw4?_smtype=3",
  [WEB_APP_LAUNCH_PAGE]: "https://amberstudent.sng.link/Djzr5/3v0b?_smtype=3",
};

export const APP_DOWNLOAD_QR_NAVBAR = {
  [PAGE.HOME]: `${BASE_IMG_URL}dWeb_home_page_navbar.svg`,
  [PAGE.SEARCH]: `${BASE_IMG_URL}dWeb_search_page_navbar.svg`,
  [PAGE.INVENTORY]: `${BASE_IMG_URL}dWeb_property_page_navbar.svg`,
  [PAGE.BLOG]: `${BASE_IMG_URL}dweb_blog_nudge_new.svg`,
};

export const APP_DOWNLOAD_QR_OFFER_SECTION = {
  [PAGE.HOME]: `${BASE_IMG_URL}dWeb_home_page_offer_section.svg`,
  [PAGE.INVENTORY]: `${BASE_IMG_URL}dWeb_property_page_offer_section.svg`,
};

export const MOBILE_APP_URL_HOME_PAGE_OFFER_SECTION =
  "https://amberstudent.sng.link/Ajzr5/k5pc?_dl=amberstudent%3A%2F%2FHome&_smtype=3";

export const DESKTOP_APP_URL_HOME_PAGE_OFFER_SECTION =
  "https://amberstudent.sng.link/Ajzr5/j294?_dl=amberstudent%3A%2F%2FHome&_smtype=3";

export const MOBILE_APP_URL_PROPERTY_PAGE_OFFER_SECTION =
  "https://amberstudent.sng.link/Ajzr5/gdgy?_dl=amberstudent%3A%2F%2FPropertyDetailsScreen&_smtype=3";

export const DESKTOP_APP_URL_PROPERTY_PAGE_OFFER_SECTION =
  "https://amberstudent.sng.link/Ajzr5/bbt3j?_dl=amberstudent%3A%2F%2FPropertyDetailsScreen&_smtype=3";

export const getPropertyShareSingularLink = (canonicalName: string) =>
  `https://amberstudent.sng.link/Ajzr5/xpd1l?_dl=amberstudent%3A%2F%2FPropertyDetailsScreen&_p=%7B%22canonical_name%22%3A%22${canonicalName}%22%7D&_smtype=3&utm_medium=app_share&utm_source=app_share&utm_campaign=app_share`;

export const MOBILE_APP_DOWNLOAD_URL_HAMBURGER =
  "https://amberstudent.sng.link/Ajzr5/xvwe?_dl=amberstudent%3A%2F%2FHome&_smtype=3";

export const APP_DOWNLOAD_URL_MOBILE_BANNER = {
  [PAGE.HOME]: `https://amberstudent.sng.link/Ajzr5/g6ir?_dl=amberstudent%3A%2F%2FHome&_smtype=3`,
  [PAGE.SEARCH]: `https://amberstudent.sng.link/Ajzr5/0q7j?_dl=amberstudent%3A%2F%2FInventorySearch&_smtype=3`,
  [PAGE.INVENTORY]: `https://amberstudent.sng.link/Ajzr5/dnr5?_dl=amberstudent%3A%2F%2FPropertyDetailsScreen&_smtype=3`,
  [PAGE.BLOG]: `https://amberstudent.sng.link/Djzr5/htgb?_smtype=3`,
  [PROFILE_DROPDOWN]:
    "https://amberstudent.sng.link/Ajzr5/xvwe?_dl=amberstudent%3A%2F%2FHome&_smtype=3",
};

export const APP_DOWNLOAD_URL_MOBILE_SMART_BANNER = {
  [PAGE.HOME]: `https://amberstudent.sng.link/Ajzr5/qj7j?_dl=amberstudent%3A%2F%2FHome&_smtype=3`,
  [PAGE.SEARCH]: `https://amberstudent.sng.link/Ajzr5/fm02?_dl=amberstudent%3A%2F%2FInventorySearch&_smtype=3`,
  [PAGE.INVENTORY]: `https://amberstudent.sng.link/Ajzr5/1s86?_dl=amberstudent%3A%2F%2FPropertyDetailsScreen&_smtype=3`,
  [PROFILE_DROPDOWN]:
    "https://amberstudent.sng.link/Ajzr5/ozer?_dl=amberstudent%3A%2F%2FMyBookings&_smtype=3",
  [REVIEW_COLLECTION]:
    "https://amberstudent.sng.link/Ajzr5/j2fpm?_dl=amberstudent%3A%2F%2FUserReviewScreen&_smtype=3",
};

export const APP_DOWNLOAD_URL_QR_NUDGE_DESKTOP = {
  [PAGE.HOME]: `${BASE_IMG_URL}dweb_home_nudge.svg`,
  [PAGE.SEARCH]: `${BASE_IMG_URL}dweb_search_nudge.svg`,
  [PAGE.INVENTORY]: `${BASE_IMG_URL}dweb_property_nudge.svg`,
  [PAGE.PROFILE]: `${BASE_IMG_URL}dweb_home_nudge.svg`,
  [PAGE.NEARBY]: `${BASE_IMG_URL}dweb_home_nudge.svg`,
  [PAGE.BLOG]: `${BASE_IMG_URL}dweb_blog_nudge_new.svg`,
};

export const APP_DOWNLOAD_URL_LINK = {
  [PAGE.HOME]: "https://amberstudent.sng.link/Djzr5/4iw4?_smtype=3",
  [PAGE.SEARCH]: "https://amberstudent.sng.link/Djzr5/xxd4?_smtype=3",
  [PAGE.INVENTORY]: "https://amberstudent.sng.link/Djzr5/8gj7?_smtype=3",
  [PAGE.PROFILE]: "https://amberstudent.sng.link/Djzr5/8gj7?_smtype=3",
};

export const CAMPAIGN_LIST_FOR_REMOVE_BOOKING_CTA = ["long_form"];
export const APP_BANNER_HEIGHT = 73;
export const APP_REVIEW = "4.5/5";
export const APP_BANNER_TEXT = "cashback on the app!";
export const APP_DOWNLOADS = "180K+ Downloads";
export const MIN_DISTANCE_VALUE = 0;
export const MAX_DISTANCE_VALUE = 20;

export const BOOK_EARLY_REGIONS = [
  "Aberdeen",
  "Belfast",
  "Birmingham",
  "Bradford",
  "Canterbury",
  "Cardiff",
  "Edinburgh",
  "Leeds",
  "Liverpool",
  "London",
  "Manchester",
  "Newcastle upon Tyne",
  "Nottingham",
  "Oxford",
  "Preston",
  "Swansea",
];

export const AMBER_LOGO_URL =
  config.BEANSTALK_APP_NAME === "webapp-hk"
    ? "https://imgix.amberstudent.cn/images/china_logo_amber.svg?auto=format&q=10"
    : "https://prod-static-assets.amberstudent.com/images/amber-hd.svg?auto=format";

export const AMBER_LOGO_URL_DARK =
  config.BEANSTALK_APP_NAME === "webapp-hk"
    ? "https://imgix.amberstudent.cn/images/logo/amber-china-logo-dark.svg?auto=format&q=40"
    : "https://prod-static-assets.amberstudent.com/images/logo/amber-logo-dark.svg?auto=format";

export const AMBER_LOGO_URL_LIGHT =
  config.BEANSTALK_APP_NAME === "webapp-hk"
    ? "https://imgix.amberstudent.cn/images/logo/amber-china-logo-light.svg?auto=format&q=10"
    : "https://prod-static-assets.amberstudent.com/images/logo/amber-logo-light.svg?auto=format";

export const AMBER_GIF_URL =
  "https://s3.ap-southeast-1.amazonaws.com/static-assets.amberstudent.com/images/amberGIfLoop1.gif";

export const JSON_SCHEMA_REMOVAL_TEST_PAGES_SLUG = [
  "barcelona-2011053744668",
  "surry-hills-1811239423025",
  "university-of-the-west-of-england-1811049440130",
  "soho-1811029029457",
  "30-kerr-parade-auburn-sydney-2309264052491",
  "academy-apartments-manchester-2105271158165",
  "campus-walk-apartments-2206158940077",
  "abbey-house-coventry-1804039830535",
];

export const MICRO_DATA_SEO_TEST_PAGES_SLUG = [
  ...JSON_SCHEMA_REMOVAL_TEST_PAGES_SLUG,
  "watford-1905111988293",
  "st-lucia-1811025596204",
  "york-1811025154987",
  "st-albans-1811236175998",
  "fitzroy-wenlock-courts-luton-1807151895941",
  "pittodrie-street-aberdeen-1901147089020",
  "london-house-stoke-on-trent-2301178492641",
  "carric-hostel-melbourne-2301031385397",
];

export const PARTNER_EVENTS = {
  pageScroll: "supply_onboard_page_scroll",
  onLandingPage: "supply_onboard_landing_page",
  onLadingFormPage: "supply_onboard_form_view",
  formSubmit: "supply_onboard_form_submit",
  ctaBtnClick: "supply_onboard_list_cta",
  category: "supply_list_with_us",
  testimonialsClick: "supply_onboard_testimonial_click",
  faqClick: "supply_onboard_faq_click",
  loginButtonClick: "supply_onboard_login_click",
};

export const COUNTRIES_WITH_MONTHLY_DURATION = ["US", "DE", "FR", "CA", "ES", "IR", "SG"];

/** Weeks per month, for the countries above that quote monthly prices. */
export const WEEKS_PER_MONTH = 4.2;
export const monthlyCountriesPriceDurationGaurd = ({ region, pricing, duration }: any) => {
  if (!COUNTRIES_WITH_MONTHLY_DURATION.includes(region?.location?.country?.short_name))
    return { pricingPrice: getAvailableStartingPricing(pricing), pricingDuration: duration };
  let convertedDuration = "";
  let convertedpricing = pricing;

  if (pricing && duration === "week") {
    const price = getAvailableStartingPricingHelper(pricing);
    const currency = getPricingCurrency(pricing?.currency) ?? "";
    convertedpricing = price ? currency + Math.floor(Number(price) * WEEKS_PER_MONTH) : null;
    convertedDuration = "month";
    return { pricingPrice: convertedpricing, pricingDuration: convertedDuration };
  }
  return { pricingPrice: getAvailableStartingPricing(pricing), pricingDuration: duration };
};

// 100% rollout — cannibalization changes enabled for all countries
export const CANNIBALIZATION_ROLLOUT: { includes: (code: string) => boolean } = {
  includes() {
    return true;
  },
};

export const COMMUNICATION_MODES = config.IS_CHINA_APP
  ? ["Wechat", "Call"]
  : ["Whatsapp", "Email", "Call"];
